var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.23,17.46a3.33,3.33,0,0,0-4.44,0L10,30.48a2.89,2.89,0,0,0,0,4.07,2.86,2.86,0,0,0,4,0l8-8.15.11,19.68a2.87,2.87,0,0,0,4.92,2,2.93,2.93,0,0,0,.83-2l-.11-19.74,8.14,8.24a2.94,2.94,0,0,0,2,.85A2.88,2.88,0,0,0,40,30.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25,12.71a1.81,1.81,0,0,0,1.8-1.8v-8a1.8,1.8,0,1,0-3.6,0v8A1.81,1.81,0,0,0,25,12.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.17,19.58a1.72,1.72,0,0,0,.89-.25,1.79,1.79,0,0,0,.66-2.45l-4-7a1.79,1.79,0,0,0-3.11,1.79l4,7A1.81,1.81,0,0,0,13.17,19.58Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.75,9.26a1.8,1.8,0,0,0-2.45.66l-4,7a1.8,1.8,0,0,0,.66,2.45,1.72,1.72,0,0,0,.9.25,1.81,1.81,0,0,0,1.55-.9l4-7A1.79,1.79,0,0,0,41.75,9.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.3651b0cf25ad13c4250f080c685a0ff4.svg";
export { ForwardRef as ReactComponent };